<style src="css/common.css"></style>
<style scoped>
.app {
  width: 7.5rem;
  margin: 0 auto;
}
.app.active {
  max-width: 14rem;
}
.messageIcon {
  position: fixed;
  bottom: 2.28rem;
  right: 0.28rem;
  background: url("~assets/message.png") no-repeat center/cover;
  width: 0.95rem;
  height: 0.95rem;
  border-radius: 50%;
}
.messageIcon2 {
  position: fixed;
  bottom: 3.5rem;
  right: 0.28rem;
  background: url("~assets/message2.png") no-repeat center/cover;
  width: 0.95rem;
  height: 0.95rem;
  border-radius: 50%;
}
/*确认取消提示*/
.maskBox {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  margin: auto;
  width: 7.5rem;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.mask {
  width: 5.6rem;
  background: #fff;
  border-radius: 0.1rem;
}

.maskTop {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.4rem 0.5rem;
}

.maskTitle {
  font-size: 0.3rem;
  color: #000;
  /*margin-bottom: .35rem;*/
  line-height: 0.42rem;
  word-break: break-all;
}

.maskTop input {
  width: 100%;
  padding: 0.16rem;
  border-radius: 0.06rem;
  font-size: 0.28rem;
  border: 0.01rem solid #00c59f;
}

input::placeholder {
  color: #999;
}

.btnBox {
  border-top: 0.01rem solid #eee;
  height: 0.95rem;
  display: flex;
  font-size: 0.3rem;
  font-weight: bold;
}

.btn {
  width: 100%;
  border-right: 0.01rem solid #eee;
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn.active {
  border-right: 0;
  color: #408bfb;
}
</style>
<template>
  <div id="app" class="app" :class="{ active: !sp }">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <div class="messageIcon" @click="toDetail()" v-if="show"></div>
    <div class="messageIcon2" @click="toDetail2()" v-if="show2"></div>
    <div class="maskBox" v-if="xxStatus">
      <div class="mask">
        <div class="maskTop">
          <div class="maskTitle">{{ message }}</div>
        </div>
        <div class="btnBox">
          <!--                  <div class="btn" @click="xxStatus=false">取消</div>-->
          <div class="btn active" @click="sure()">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "normalize.css";
import { getSource, getSources } from "./api";
export default {
  name: "app",
  data() {
    return {
      sp: localStorage.getItem("sp") ? localStorage.getItem("sp") : "",
      show: false,
      show2: false,
      xxStatus: false,
      message: "",

      //    心理矫治
      companyId: this.$route.query.companyId ? this.$route.query.companyId : "1001",
      userCode: this.$route.query.userCode ? this.$route.query.userCode : "",
      sourceType: this.$route.query.sourceType ? this.$route.query.sourceType : "",
      token: this.$route.query.token
        ? this.$route.query.token
        : localStorage.getItem("token")
        ? localStorage.getItem("token")
        : "",
      id: this.$route.query.id
        ? this.$route.query.id
        : localStorage.getItem("id")
        ? localStorage.getItem("id")
        : "",
    };
  },
  mounted() {
    localStorage.setItem("sp", false);
    console.log(1111111111111);
    this.forScaleUserLogin();
    console.log(this.$route.fullPath);
    console.log(this.$route.query.code);
    if (this.$route.query.loginType) {
      localStorage.setItem("loginType", this.$route.query.loginType);
    }

    if (this.companyId && this.userCode && this.token) {
      this.scaleUserAutoLogin();
    } else {
      // if(!localStorage.getItem('userId')&&this.$route.path!=='/login'){
      //
      //     if(this.$route.query.code){
      //         this.$router.push(`/login?next=${encodeURIComponent(this.$route.fullPath)}&code=${this.$route.query.code}`)
      //     }else{
      //         this.$router.push(`/login?next=${encodeURIComponent(this.$route.fullPath)}`)
      //     }
      // }
    }

    window.onload = function () {
      // 禁止双指缩放
      document.addEventListener("touchstart", function (event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      // 禁止ios 双击缩放
      let lastTouchEnd = 0;
      document.addEventListener(
        "touchend",
        function (event) {
          let now = new Date().getTime();
          if (now - lastTouchEnd <= 300) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        },
        false
      );
      document.addEventListener("gesturestart", function (event) {
        event.preventDefault();
      });
    };
    // this.webSocket();
  },
  methods: {
    async scaleUserAutoLogin() {
      let data = await getSources(
        "/bear-scale/api/scaleUserInfo/scaleUserAutoLogin.json",
        {
          companyId: this.companyId,
          userCode: this.userCode,
          sourceType: this.sourceType,
          token: this.token,
        }
      );
      if (data.status === 0) {
        localStorage.setItem("userId", data.scaleUser.userId);
        localStorage.setItem("nickName", data.scaleUser.nickName);
        localStorage.setItem(
          "companyId",
          data.scaleUser.companyId ? data.scaleUser.companyId : "1001"
        );
        localStorage.setItem(
          "userPhone",
          data.scaleUser.userPhone ? data.scaleUser.userPhone : ""
        );
        if (this.$route.query.next) {
          //                    location.href =
          this.$router.replace(`${this.$route.query.next}`);
          //                    console.log(this.$route)
        } else {
          if (data.scaleUser.companyId == 10015) {
            this.$router.replace(`/correct`);
          } else {
            this.$router.replace(`/`);
          }
        }
      } else {
        this.message = data.msg;
        this.xxStatus = true;
      }
    },
    sure() {
      this.message = "";
      this.xxStatus = false;
      var ua = navigator.userAgent;
      var isIos = /iPhone/i.test(ua);
      var isAndroid = /Android/i.test(ua);
      isIos &&
        window.webkit.messageHandlers.tellAppData.postMessage("backbackback");
      isAndroid && obj.tellAppData("backbackback");
    },
    async forScaleUserLogin() {
      if (this.id && this.token) {
        let data = await getSources(
          "/bear-scale/api/scaleUserInfo/forScaleUserLogin.json",
          {
            id: this.id,
            token: this.token,
          }
        );
        if (data.status === 0) {
          localStorage.setItem("loginType", data.loginType);
          localStorage.setItem("companyLogo", data.companyLogo);
          localStorage.setItem("token", this.token);
          localStorage.setItem("id", this.id);
          // this.$store.commit('setLoginType', data.loginType)
        }
      }
    },
    loginSuccess() {
      if (this.$route.query.next) {
        //                    location.href =
        this.$router.replace(`${this.$route.query.next}`);
        //                    console.log(this.$route)
      } else {
        this.$router.replace(`/`);
      }
    },
    getCookie(key) {
      let cookieStr = document.cookie.split("; ");
      for (let i = 0; i < cookieStr.length; i++) {
        let tempArr = cookieStr[i].split("=");
        if (tempArr[0] == key) {
          return tempArr[1];
        }
      }
      return null;
    },
    toDetail() {
      this.show = false;
      this.$router.push(`/askExpert?${Math.random()}`);
    },
    toDetail2() {
      this.show2 = false;
      this.$router.push(`/psychologyList?${Math.random()}`);
    },
    webSocket() {
      let that = this;
      let websocket = null;
      //判断当前浏览器是否支持WebSocket

      let userId = localStorage.getItem("userId");

      //                "wss://www.liminghulian.com/websocket");
      if ("WebSocket" in window) {
        if (userId) {
          //                      线上
          //                         websocket = new WebSocket(`wss://manage.120xinmao.com/userSocket/?doctorId=${userId}`);
          //                        248测试
          //                        websocket = new WebSocket(`ws://192.168.0.247:8088/depression-mip/userWebSocket/${userId}`);
          //                        websocket = new WebSocket(`ws://192.168.3.105:8091/bear-scale/userSocket/${userId}`);
          websocket = new WebSocket(
            `ws://106.54.86.69:8091/bear-scale/userSocket/${userId}`
          );
        } else {
          // websocket = new WebSocket(`wss://manage.120xinmao.com/userSocket/?doctorId=-1`);

          //                        websocket = new WebSocket(`ws://192.168.0.247:8088/depression-mip/userWebSocket/-1`);
          //                        websocket = new WebSocket(`ws://192.168.3.105:8091/bear-scale/userSocket/-1`);
          websocket = new WebSocket(
            `ws://106.54.86.69:8091/bear-scale/userSocket/-1`
          );
        }
      } else {
        alert("当前浏览器不支持websocket");
      }

      //发送消息
      function send() {
        var message = document.getElementById("text").value;
        websocket.send(message);
      }

      //接收到消息的回调方法
      websocket.onmessage = function (event) {
        console.log(event);
        heartCheck.reset().start();
        let data = JSON.parse(event.data);
        console.log(data);
        console.log(data.msg);

        if (data) {
          that.$store.commit("setInfo", data);
          // that.$store.commit('setInfo2', data.qxh)

          // if(data.qid){
          //     that.show=true
          // }else{
          //     that.show2=true
          // }
        }
      };

      //连接成功建立的回调方法
      websocket.onopen = function () {
        heartCheck.reset().start();
        console.log("onopen...");
      };
      //连接关闭的回调方法
      websocket.onclose = function () {
        console.log("onclose...");
      };
      //连接发生错误的回调方法
      websocket.onerror = function () {
        console.log("onerror...");
      };
      //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
      window.onbeforeunload = function () {
        closeWebSocket();
      };

      //关闭WebSocket连接
      function closeWebSocket() {
        websocket.close();
      }

      // 心跳检测, 每隔一段时间检测连接状态，如果处于连接中，就向server端主动发送消息，来重置server端与客户端的最大连接时间，如果已经断开了，发起重连。
      var heartCheck = {
        timeout: 55000, // 9分钟发一次心跳，比server端设置的连接时间稍微小一点，在接近断开的情况下以通信的方式去重置连接时间。
        serverTimeoutObj: null,
        reset: function () {
          clearTimeout(this.timeoutObj);
          clearTimeout(this.serverTimeoutObj);
          return this;
        },
        start: function () {
          var self = this;
          this.serverTimeoutObj = setInterval(function () {
            if (websocket.readyState == 1) {
              console.log("连接状态，发送消息保持连接");
              websocket.send("ping");
              heartCheck.reset().start(); // 如果获取到消息，说明连接是正常的，重置心跳检测
            } else {
              console.log("断开状态，尝试重连");
              self.webSocket();
            }
          }, this.timeout);
        },
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue?adc773f8